export default __webpack_public_path__ + "media/images/check-faded-golden-425b77f0.svg";